import clsx from 'clsx';
import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import { FadeIn } from 'components/common/FadeIn';
import { EnterButton } from 'components/home-page/enter-button/EnterButton';
import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';

import QuestionsAndAnswers from './questions-and-answers';
import styles from './QuickAnswers.module.css';

const QuickAnswers = observer(() => {
  const userStore = useUserStore();
  const showEnterButton = !userStore.subscriptionStatusInfo.subscriberStatus;

  return (
    <div className={clsx('daymadeTypographyReset', styles.questions)}>
      <AboutUsModule background="white" withMorePadding>
        <AboutUsSiteContainer styles2026>
          <div className={styles.introHeading}>
            <FadeIn onScroll>
              <div className={styles.headingContainer}>
                <p className="daymadeTypographyTaglineAccent">
                  You might be wondering...
                </p>
                <h2 className="daymadeTypographyXL">Quick answers</h2>
              </div>
            </FadeIn>
            {showEnterButton && (
              <div className="desktopOnly">
                <EnterButton
                  overrideButtonText="Enter to Win"
                  overrideReferralText
                  dm2026Button
                  buttonSize="Large"
                  minWidth={240}
                />
              </div>
            )}
          </div>
          <div className={styles.mainContent}>
            <QuestionsAndAnswers />
          </div>
          {showEnterButton && (
            <FadeIn className={clsx(styles.enterCTA, 'mobileOnly')} onScroll>
              <EnterButton
                overrideButtonText="Enter to Win"
                overrideReferralText
                dm2026Button
                buttonSize="Large"
                minWidth={240}
              />
            </FadeIn>
          )}
        </AboutUsSiteContainer>
      </AboutUsModule>
    </div>
  );
});

export default QuickAnswers;
